import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ShippingRegionDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingRegionDetailService extends TmsWebBaseEditCreateService<
  ShippingRegionDetails,
  ShippingRegionDetails
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShippingRegionDetail', $localize`Shipping Region Detail`);
  }

  getForShippingRegionHeader(id: string): Observable<ShippingRegionDetails[]> {
    return this.httpService.get<ShippingRegionDetails[]>(`${this.apiUrl}/GetForShippingRegionHeader?id=${id}`);
  }
}
